"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
const helpers_1 = require("../../../../scripts/helpers");
const initProductCard = ($productCard) => {
    const variants = JSON.parse($productCard.getAttribute('data-variants'));
    const data = {
        currentVariantId: variants[0].id,
    };
    (0, helpers_1.listenPropChange)(data, 'currentVariantId', (newId) => {
        updateData(newId);
    });
    const updateData = (variantId) => {
        const variantData = variants.find(item => item.id === variantId);
        if (!variantData)
            return;
        // Обновляем данные на основе data-prop-bind-name
        $productCard.querySelectorAll('[data-prop-bind-name]').forEach($el => {
            const propName = $el.getAttribute('data-prop-bind-name');
            if (!propName || !(propName in variantData))
                return;
            const newValue = propName.includes('price') ? (0, helpers_1.formatPrice)(variantData[propName]) : variantData[propName];
            if ($el.getAttribute('data-prop-change-type') === 'attr') {
                const attrName = $el.getAttribute('data-prop-change-attr-name');
                if (attrName)
                    $el.setAttribute(attrName, newValue);
            }
            else {
                $el.textContent = newValue;
            }
        });
        // Обновляем отображение old_price (если есть)
        const $oldPrice = $productCard.querySelector('.product-card__price-prev');
        if ($oldPrice) {
            if (variantData.old_price) {
                $oldPrice.style.display = '';
            }
            else {
                $oldPrice.style.display = 'none';
            }
        }
    };
    const $swiper = $productCard.querySelector('.swiper');
    const $prevButton = $productCard.querySelector('.product-card__slider-controls-button-prev');
    const $nextButton = $productCard.querySelector('.product-card__slider-controls-button-next');
    const $pagination = $productCard.querySelector('.swiper-pagination');
    let paginationButtonsList = null;
    if ($swiper && $prevButton && $nextButton && $pagination) {
        new swiper_1.default($swiper, {
            slidesPerView: 'auto',
            modules: [modules_1.Navigation, modules_1.Pagination],
            loop: $swiper.getElementsByClassName('.swiper-slide').length > 1,
            centeredSlides: false,
            watchSlidesProgress: true,
            navigation: {
                enabled: true,
                prevEl: $prevButton,
                nextEl: $nextButton,
            },
            lazyPreloadPrevNext: 2,
            pagination: {
                el: $pagination,
                type: 'bullets',
                bulletElement: 'button',
                clickable: true,
                renderBullet: (index, className) => `<div class="${className}"><span></span></div>`,
            },
            on: {
                init: swiper => {
                    swiper.update();
                },
                slideChange: swiper => {
                    let currentActiveBulletIndex = 0;
                    if (paginationButtonsList) {
                        const $activeBullet = $pagination.querySelector('.swiper-pagination-bullet-active');
                        if ($activeBullet) {
                            if (paginationButtonsList.length > 1)
                                $pagination.style.display = '';
                            else
                                $pagination.style.display = 'none';
                            const currentActiveBulletIndex = paginationButtonsList.findIndex(item => item === $activeBullet);
                            paginationButtonsList.forEach(($bullet, index) => {
                                const diffIndexes = Math.abs(currentActiveBulletIndex - index);
                                const scale = diffIndexes < 4 ? 1 - diffIndexes * 0.2 : 1 - 4 * 0.2;
                                $bullet.style.transform = `translateX(-${14 * currentActiveBulletIndex}px) scale(${scale})`;
                            });
                            /* Обновляем данные */
                            data.currentVariantId = variants[currentActiveBulletIndex].id;
                        }
                    }
                },
                paginationRender: () => {
                    paginationButtonsList = Array.from($pagination.querySelectorAll('.swiper-pagination-bullet'));
                    if (paginationButtonsList.length > 1)
                        $pagination.style.display = '';
                    else
                        $pagination.style.display = 'none';
                    const $activeBullet = $pagination.querySelector('.swiper-pagination-bullet-active');
                    if ($activeBullet) {
                        if (paginationButtonsList.length > 1)
                            $pagination.style.display = '';
                        else
                            $pagination.style.display = 'none';
                        const currentActiveBulletIndex = paginationButtonsList.findIndex(item => item === $activeBullet);
                        paginationButtonsList.forEach(($bullet, index) => {
                            const diffIndexes = Math.abs(currentActiveBulletIndex - index);
                            const scale = diffIndexes < 4 ? 1 - diffIndexes * 0.2 : 1 - 4 * 0.2;
                            $bullet.style.transform = `translateX(-${14 * currentActiveBulletIndex}px) scale(${scale})`;
                        });
                    }
                },
            },
        });
    }
};
exports.default = initProductCard;
